import React, { useState } from 'react';
import { Users, Info } from 'lucide-react';
import type { Plant } from '../../../../types/plant';
import CompanionPlantPreview from '../../../modals/CompanionPlantPreview';
import CompanionPlantModal from '../../../modals/CompanionPlantModal';

interface CompanionsProps {
  plant: Plant;
}

export default function Companions({ plant }: CompanionsProps) {
  const [selectedCompanion, setSelectedCompanion] = useState<any | null>(null);
  const companions = [
    ...(plant.companion_plants || []),
    ...(plant.companion_plants_reverse || [])
  ];

  if (!companions.length) {
    return (
      <section className="bg-white rounded-lg shadow-sm p-6">
        <h2 className="text-2xl font-semibold mb-6">Companion Plants</h2>
        <p className="text-gray-600">No companion plants found for this plant.</p>
      </section>
    );
  }

  return (
    <section className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center gap-2 mb-6">
        <Users className="h-6 w-6 text-primary-500" />
        <h2 className="text-2xl font-semibold">Companion Plants</h2>
      </div>

      <div className="space-y-4">
        {companions.map((companion, index) => (
          <CompanionPlantPreview
            key={`${companion.id}-${index}`}
            companion={companion}
            onClose={() => {}}
            onPlantClick={() => setSelectedCompanion(companion)}
          />
        ))}
      </div>

      {selectedCompanion && (
        <CompanionPlantModal
          isOpen={true}
          onClose={() => setSelectedCompanion(null)}
          plant={selectedCompanion.companion_plant || selectedCompanion.plant}
          benefits={selectedCompanion.benefits}
        />
      )}
    </section>
  );
}